import { Platform } from '@ps-int/promozavr/app/types';

import {
    PROMOZAVR_PERSISTENT_PROJECT,
    PROMOZAVR_PERSISTENT_QUEUE,
    PROMOZAVR_PERSISTENT_TOUCH_PROJECT,
    PROMOZAVR_PROJECT,
    PROMOZAVR_REGULAR_QUEUE,
    PROMOZAVR_TOUCH_PROJECT,
    type PromozavrProject,
    type PromozavrQueueKind,
} from './types';

const PROMOZAVR_DESKTOP_PROJECT_BY_QUEUE: Record<
    PromozavrQueueKind,
    typeof PROMOZAVR_PROJECT | typeof PROMOZAVR_PERSISTENT_PROJECT
> = {
    [PROMOZAVR_REGULAR_QUEUE]: PROMOZAVR_PROJECT,
    [PROMOZAVR_PERSISTENT_QUEUE]: PROMOZAVR_PERSISTENT_PROJECT,
};

const PROMOZAVR_TOUCH_PROJECT_BY_QUEUE: Record<
    PromozavrQueueKind,
    typeof PROMOZAVR_TOUCH_PROJECT | typeof PROMOZAVR_PERSISTENT_TOUCH_PROJECT
> = {
    [PROMOZAVR_REGULAR_QUEUE]: PROMOZAVR_TOUCH_PROJECT,
    [PROMOZAVR_PERSISTENT_QUEUE]: PROMOZAVR_PERSISTENT_TOUCH_PROJECT,
};

export function getPromozavrProjectByQueue(queue: PromozavrQueueKind, isTouch = false): PromozavrProject {
    return isTouch ? PROMOZAVR_TOUCH_PROJECT_BY_QUEUE[queue] : PROMOZAVR_DESKTOP_PROJECT_BY_QUEUE[queue];
}

export function getPromozavrPlatform(isTouch: boolean): Platform {
    return isTouch ? Platform.touch : Platform.desktop;
}
